<script>
/**
 * ****************************************************************************
 * @description     :   Button component
 * @created at      :   2024/08/01
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of button component
 */
var AnsTooltip = {
    template: template,
    props: {
        value: {
            type: String,
            default: ''
        },
        titleValue: {
            type: String,
            default: ''
        },
        classButton: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: '0'
        },
        parentWidth: {
            type: [String, Number],
            default: 456
        },
        elementType: {
            type: String,
            default: 'span',
            validator(value) {
                return ['button', 'span', 'div'].includes(value);
            }
        },
        customTooltipClass: {
            type: String,
            default: ''
        },
        customStyle: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            showTooltip: false
        };
    },
    watch: {
        value: {
            handler: 'checkShowTooltipTable',
            immediate: true
        },
        titleValue: {
            handler: 'checkShowTooltipTable',
            immediate: true
        },
        parentWidth: {
            handler: 'checkShowTooltipTable',
            immediate: true
        }
    },
    computed: {
        renderTitle() {
            return this.showTooltip ? this.value : '';
        }
    },
    methods: {
        checkShowTooltipTable() {
            this.$nextTick(() => {
                const tooltipElement = this.$refs.tooltip;
                if (!tooltipElement) return;

                tooltipElement.style.width = 'auto';
                tooltipElement.style.display = 'inline-block';
                tooltipElement.style.whiteSpace = 'nowrap';

                const realWidth = tooltipElement.offsetWidth;
                const isPercentage = String(this.parentWidth).includes('%');

                if (isPercentage) {
                    tooltipElement.style.width = `${this.parentWidth}`;
                    this.showTooltip = true;
                } else {
                    const numericWidth = parseFloat(this.parentWidth);
                    tooltipElement.style.width = `${numericWidth}px`;
                    this.showTooltip = realWidth > numericWidth;
                }
                if (this.titleValue) {
                    this.showTooltip = true;
                }

                tooltipElement.style.textOverflow = 'ellipsis';
                tooltipElement.style.overflow = 'hidden';
                tooltipElement.style.whiteSpace = 'nowrap';
            });
        }
    }
};
export default AnsTooltip;
</script>
